var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightIconCheckEligibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5476 18.6326C2.05325 19.3248 1.09517 19.3947 0.515584 18.7813L0.395535 18.6542C-0.0712325 18.1602 -0.132145 17.3813 0.251551 16.8126L6.18768 9.55494L0.251663 2.38729C-0.132033 1.81872 -0.0711365 1.03984 0.395647 0.545759L0.515695 0.418687C1.09528 -0.194801 2.05334 -0.124721 2.5477 0.567327L9.32672 8.69285C9.69104 9.20288 9.69104 9.90704 9.32672 10.417L2.5476 18.6326Z",
    fill: "#031434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRightIconCheckEligibility);
export default __webpack_public_path__ + "static/media/chevron_right_icon_checkEligibility.75ab709dff5b89a5d62bb97b99e21869.svg";
export { ForwardRef as ReactComponent };